module.exports = __webpack_public_path__ + "img/05j-Buy_Callidus02.44773394.jpg";